import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
//Style
import { useStyles } from 'components/sheets/AccountImportSheet/AccountImportSheet.style';
//Mui components
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormLabel from '@mui/material/FormLabel';
import Alert from '@mui/lab/Alert';
// PCP Components
import Dropzone from 'components/commons/Dropzone.jsx';
// Locales
import translate from 'locales/i18n';
//Tools
import Facade from 'core/Facade';
//Actions
import AccountStore from 'stores/AccountStore';
import AccountAction from 'actions/AccountAction';

const AccountImportSelect = ({
    errorMessages,
    file,
    importType,
    selectedAccount,
    setFileAndResetMatching,
    setImportType,
    setSelectedAccount
}) => {

    const [accounts, setAccounts] = useState(AccountStore.getAccounts());

    const classes = useStyles();

    useEffect(() => {
        AccountAction.getAccounts();
    }, []);

    useEffect(() => {
        accounts && setSelectedAccount(accounts.find(a => a.id === Facade.getUrlParam('account')));
    }, [accounts]);

    useEffect(() => {
        AccountStore.addChangeListener(onAccountStoreChanges);
        return () => AccountStore.removeChangeListener(onAccountStoreChanges);
    }, []);

    const onAccountStoreChanges = () => setAccounts(AccountStore.getAccounts());

    return (
        <div>
            <div className={classes.formContent}>
                <FormControl variant='outlined' className={classes.formControl}>
                    <InputLabel htmlFor='outlined' margin={'dense'}>
                        {translate.i18n('ACCOUNT')}
                    </InputLabel>
                    <Select
                        value={selectedAccount ? selectedAccount : {}}
                        onChange={(event) => {
                            setSelectedAccount(event.target.value);
                        }}
                        margin={'dense'}
                        style={{ marginBottom: '10px' }}
                        label={translate.i18n('ACCOUNT')}>
                        {accounts.filter(account => account.modules.spe).map(account =>
                            <MenuItem key={account.name} value={account}>{account.name}</MenuItem>
                        )}
                    </Select>
                    <FormLabel id='importType'>Importer : </FormLabel>
                    <RadioGroup
                        aria-labelledby='importType'
                        value={importType}
                        onChange={e => setImportType(e.target.value)}
                    >
                        <FormControlLabel value='account' control={<Radio color='primary' />} label='Compte' />
                        <FormControlLabel value='additionalData' control={<Radio color='primary' />} label='Données additionelles' />
                    </RadioGroup>
                </FormControl>
            </div>
            <div className={classes.formContent} >
                <Dropzone
                    uploadText={translate.i18n('DROP_HERE')}
                    setFile={(newFile) => {
                        setFileAndResetMatching(newFile);
                    }}
                    file={file}
                    width={400}
                    title={translate.i18n('SELECT_FILE')}
                    emptyText={translate.i18n('FILE_NAME') + ' ...'}
                />
            </div>
            {errorMessages.length > 0 &&
                <div className={classes.errorZone}>
                    <Alert severity='error' style={{ width: '400px' }}>
                        {errorMessages.map((error, index) => <span className={classes.errorMessage} key={index}>{error} <br /> </span>)}
                    </Alert>
                </div>
            }
        </div>
    );
};

AccountImportSelect.propTypes = {
    errorMessages: PropTypes.array,
    file: PropTypes.object,
    importType: PropTypes.string,
    selectedAccount: PropTypes.object,
    setFileAndResetMatching: PropTypes.func,
    setImportType: PropTypes.func,
    setSelectedAccount: PropTypes.func
};

export default AccountImportSelect;
